module.exports = __webpack_public_path__ + "static/media/brush.5d422713.svg";